
import wx from 'weixin-js-sdk'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'orderDetail',
directives: {
TransferDom
},
components: {
wx,  Popup,XButton,Datetime
},
data () {
return {
id:0,
deliveryStatus:false,
info:{},
filePath: [],
formData:{
id:0,
pics:[],
},
datetimeStatus:false,
startDate:'',
endDate:'',
minHour:8,
maxHour:21,
days:30,
}
},
created(){
this.id = Number(this.$route.params.id);
this.formData.id = this.id;
if(!this.$func.getLocal('token')){
this.getCode();
}else{
this.getInfo();
}
this.config();
this.setDate();
},
amount(){
},
methods:{
getCode(){
var local = window.location.href
this.code = this.getUrlCode().code



var appid = 'wx109fd072a29dad94';

if (this.code == null || this.code === '') {
window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
} else {
this.login();
}
},
getUrlCode() {
var url = window.location.href
var theRequest = new Object()
if (url.indexOf("?") != -1) {
var urls = url.split("?")
var strs = urls[1].split("&")
for(var i = 0; i < strs.length; i++) {
theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
}
}
var code = theRequest.code;
if(code == 'undefined' || code == null || code === ''){
this.$func.setLocal('channel',parseInt(theRequest.channel));
}
return theRequest
},
login(){
this.$api.login({code:this.code,channel:this.$func.getLocal('channel')}).then((res)=>{
if(res){
if(res.data.token){
this.$func.setLocal('token',res.data.token);
this.getInfo();
}
}
})
},
copy(val){
this.$func.copy(val,event);
},
getInfo(){
this.$api.orderDetial({id:this.id}).then((res)=>{
if(res){
this.info = res.data;
}
})
},
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
hour: nowDate.getHours(),
}
this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
this.minHour = date.hour+1;
if(nowDate.getHours() >= this.maxHour-1){
var date = new Date(this.startDate);
date.setDate(date.getDate() + 1);
var date1 = {
year: date.getFullYear(),
month: date.getMonth() + 1,
day: date.getDate(),
}
this.startDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
}
var date = new Date(this.startDate);
date.setDate(date.getDate() + this.days);
var date1 = {
year: date.getFullYear(),
month: date.getMonth() + 1,
day: date.getDate(),
}
this.endDate = date1.year + '-' + (date1.month >= 10 ? date1.month : '0' + date1.month) + '-' + (date1.day >= 10 ? date1.day : '0' + date1.day);
},

datetimeShow(){
this.datetimeStatus = true;
},
datetimeChange(val){

this.info.home_time = val;
this.$api.editHomeTime({id:this.id,home_time:val}).then((res)=>{
if(res){
this.$func.showToast('已修改');
}
})
this.datetimeStatus = false;
},
showPic(index) {
wx.previewImage({
current: this.info.problem.pics_path[index], // 当前显示图片的http链接
urls: this.info.problem.pics_path
});
},
showPic1(index) {
wx.previewImage({
current: this.filePath[index], // 当前显示图片的http链接
urls: this.filePath 
});
},
delivery(){
this.deliveryStatus = true;
},
closeDelivery(){
this.deliveryStatus = false;
this.filePath = [];
this.formData.pics = [];
},
changeStatus(id,status){
let that = this;
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
that.$func.confirm('确认操作？','提示',()=>{
that.$api.changeStatus({id:id,status:status,type:that.info.type}).then((res)=>{
if(res){
setTimeout(()=>{
that.getInfo();
}, 300);
}
});
})
},
submitDelivery(){
let that = this;
that.$func.confirm('确认已配送？','提示',()=>{
that.$api.submitDelivery(that.formData).then((res)=>{
if(res){
that.deliveryStatus = false;
that.filePath = [];
that.formData.pics = [];
that.getInfo();
}
});
})

},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
]
});
}
})
},
uploadFile(){
let that = this;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let localId = localIds.pop();
let that = this;
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImg({serverId:res.serverId,path:'delivery'}).then((res)=>{
if(res){
that.filePath.push(res.data.url);
that.formData.pics.push(res.data.path);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},

delImg(index){
this.filePath.splice(index,1);
this.formData.pics.splice(index,1);
},
}
}



// WEBPACK FOOTER //
// ./src/pages/orderDetail.vue